import { CHAT_EVENT_PARTICIPANTS, CHAT_EVENTS, ChatEvent, ChatEventParticipant } from "../../db/chat";
import { RealtimeDatabase as Database, RealtimeReference } from "../../db/common";
import { BaseDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Event Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatEventService extends BaseDatabaseService<ChatEvent> {
    protected getBasePath(): string {
        return CHAT_EVENTS;
    }

    //make it public for sub on change for FE
    public getEntityRef(eventId: string): RealtimeReference {
        return super.getEntityRef(eventId);
    }

    public participantsService(eventId: string) {
        return new ChatEventParticipantsService(this.db, eventId);
    }
}

class ChatEventParticipantsService extends BaseDatabaseService<ChatEventParticipant> {
    constructor(protected db: Database, protected eventId: string) {
        super(db)
    }
    protected getBasePath(): string {
        return `${CHAT_EVENTS}/${this.eventId}/${CHAT_EVENT_PARTICIPANTS}`
    }
}